import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { PedidoModel } from '../../models/pedido.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { AreaCartaoComponent } from './area-cartao/area-cartao.component';
import { AreaTrocoComponent } from './area-troco/area-troco.component';
import { MudarFocoService } from 'src/app/core/services/behavior/mudar-foco.service';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
  selector: 'app-escolher-forma-pgto-dialog',
  templateUrl: './escolher-forma-pgto-dialog.component.html',
  styleUrls: ['./escolher-forma-pgto-dialog.component.scss']
})
export class EscolherFormaPgtoDialogComponent implements OnInit {
  // componentProps
  private readonly pedido: PedidoModel;

  @ViewChild(AreaCartaoComponent) private _areaCartaoComponent: AreaCartaoComponent;
  @ViewChild(AreaTrocoComponent) private _areaTrocoComponent: AreaTrocoComponent;
  @ViewChild("textareaObservacoes") private _textareaObservacoes: ElementRef<HTMLTextAreaElement>

  public formaPgtoAtiva: 'Dinheiro' | 'Cartao' | 'Pix' = 'Dinheiro';
  public observacaoDigitada = '';

  constructor(
    private _modalCtrl: ModalController,

    private _mudarFocoService: MudarFocoService
  ) { }

  public get nomeCliente() {
    return this.pedido?.cliente?.nome ?? '';
  }

  public get totalPedido() {
    return HelpersUtil.sumArray(this.pedido.dets);
  }

  public async confirmarAsyncOnClick() {
    await this._confirmarAsync();
  }

  public ngOnInit() {
    this._mudarFocoService.mudarFoco$.subscribe(res => {
      if (res) this._textareaObservacoes.nativeElement.focus();
    })
  }

  @HostListener('window:keydown', ['$event'])
  private async handleKeyboardEventAsync(event: KeyboardEvent) {
    switch (event.key) {
      case KeyboardKeysEnum.F5:
        event.preventDefault();
        event.stopPropagation();

        await this.confirmarAsyncOnClick();
        break;
      case KeyboardKeysEnum.F1:
        event.preventDefault();
        event.stopPropagation();

        if (this.formaPgtoAtiva === 'Dinheiro')
          this.formaPgtoAtiva = "Pix"
        else if (this.formaPgtoAtiva === 'Pix')
          this.formaPgtoAtiva = "Cartao"
        else if (this.formaPgtoAtiva === 'Cartao')
          this.formaPgtoAtiva = "Dinheiro"

        break;

      case KeyboardKeysEnum.Escape:
        await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
        
        DialogStateUtil.dialogIsClosed();

        break;
    }
  }

  private async _confirmarAsync() {
    let dataClose: EscolherFormaPgtoDialogDataClose;

    switch (this.formaPgtoAtiva) {
      case 'Cartao':
        dataClose = this._confirmarPagamentoComCartao();
        break;
      case 'Dinheiro':
        dataClose = this._confirmarPagamentoEmDinheiro();
        break;
      case 'Pix':
        dataClose = this._confirmarPagamentoEmPix();
        break;
    }

    dataClose.observacao = this.observacaoDigitada;

    await this._modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);

    DialogStateUtil.dialogIsClosed();
  }

  private _confirmarPagamentoComCartao() {
    const bandeiraCartao = this._areaCartaoComponent.bandeiraCartaoSelecionada;

    return new EscolherFormaPgtoDialogDataClose('Cartao', null, bandeiraCartao.nome, this.observacaoDigitada);
  }

  private _confirmarPagamentoEmDinheiro() {
    const troco = this._areaTrocoComponent.trocoDigitado;

    return new EscolherFormaPgtoDialogDataClose('Dinheiro', troco, null, this.observacaoDigitada);
  }

  private _confirmarPagamentoEmPix() {
    return new EscolherFormaPgtoDialogDataClose('Pix', null, null, this.observacaoDigitada);
  }
}

export class EscolherFormaPgtoDialogDataClose {
  constructor(
    public formaPgto: 'Dinheiro' | 'Cartao' | 'Pix',
    public troco = 0,
    public bandeiraCartao = '',
    public observacao = ''
  ) { }
}
